import React from 'react'

import PropTypes from 'prop-types'

import { InsertDriveFile } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { getFileExtension, getFileName } from '~/src/Lib/Utils/hooks/filestack'
import DiscardIcon from '~/src/UI/Icons/Discard'
import Button from '~/src/UI/Shared/Button'
import T from '~/src/UI/Shared/Typography'

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '14rem',
    padding: '4px 8px',
    '&:before': {
      borderRadius: theme.shape.borderRadius,
    },
  },
  iconOverride: {
    color: ({ error, onDelete }) => {
      if (error) return theme.palette.error.inactive
      if (onDelete) return theme.palette.appPrimary.inactive
      return theme.palette.text.secondary
    },
    '& > *:first-child': {
      fontSize: '1.5rem',
    },
  },
  discardButton: {
    marginLeft: '4px',
    marginRight: '-4px',
    padding: 0,
  },
}))

const AttachmentButton = ({
  attachment,
  error = null,
  onDelete = undefined,
  ...passthru
}) => {
  const classes = useStyles({ error, onDelete })
  const extension = getFileExtension(attachment)
  const basename = getFileName(attachment).replace(extension, '')

  return (
    <Button
      muiClasses={{ iconSizeMedium: classes.iconOverride }}
      className={classes.root}
      disableElevation
      startIcon={<InsertDriveFile />}
      sx={theme => ({
        border: `1px solid ${
          onDelete ? theme.palette.appPrimary.disabled : theme.palette.white.active
        }`,
        '& p': {
          color: onDelete ? theme.palette.appPrimary.main : theme.palette.text.secondary,
        },
      })}
      {...passthru}
    >
      <T noWrap component="span">{basename}</T>
      <T component="span">{extension}</T>
      {onDelete ? (
        <IconButton
          className={classes.discardButton}
          size="small"
          onClick={event => {
            event.stopPropagation()
            onDelete()
          }}
        >
          <DiscardIcon />
        </IconButton>
      ) : null}
    </Button>
  )
}

AttachmentButton.propTypes = {
  attachment: PropTypes.shape({
    filename: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  onDelete: PropTypes.func,
}

export default AttachmentButton
